

































































import {Component, Vue, Watch} from "vue-property-decorator";
import {LadingErrorParams} from "@/modules/ladingerror/params";
import {LadingErrorStatus} from "@/enums/status/ladingerror";
import debounce from "lodash/debounce";
import {LadingErrorStore} from "@/modules/ladingerror/store";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {EmployeeType} from "@/enums/type";
import {allLadingError} from "@/modules/ladingerror/services";
import {LadingStatus} from "@/enums/status";
import TableToExcel from "@linways/table-to-excel";
import LadingErrorExcel from "@/modules/ladingerror/List/components/Excel.vue";

@Component({
  name: "LadingErrorSearch",
  components: {LadingErrorExcel, EnumSelector, EmployeeSelector, CustomerSelector, MillisecondDatePicker}
})
export default class extends Vue {
  form = new LadingErrorParams();
  LadingErrorStatus = LadingErrorStatus;
  EmployeeType = EmployeeType;
  LadingStatus = LadingStatus;
  limitStatus = [
      LadingStatus.DonSuCo,
      LadingStatus.PhatLai,
      LadingStatus.ChuyenTiep,
      LadingStatus.DuyetHoan,
      LadingStatus.PhanCongPhat
  ]
  isExporting = false;
    dataSourceExcel = [] as any;

    @Watch('form', {immediate: false, deep: true})
  onValueChange(val: any) {
    this.handleChange(val)
  }
  
  handleChange = debounce(function (val) {
    LadingErrorStore.updateLadingErrorParams(val)
      LadingErrorStore.listLadingError({...val, page: 1})
  }, 500)

    async exportExcel() {
        try {
            this.dataSourceExcel = await this.getAllLadingError();
            console.log("data excel error = ", this.dataSourceExcel)
            setTimeout(() => {
                TableToExcel.convert(document.getElementById("table-excel-lading-error"), {
                    name: `Đơn sự cố.xlsx`,
                    sheet: {
                        name: "Sheet 1"
                    }
                });
            }, 200)
        } catch (e) {
        }
    }

  async getAllLadingError() {
    try {
      this.isExporting = true;
      const {data} = await allLadingError(LadingErrorStore.params);
      return data.datas;
    } catch (e) {
    } finally {
      this.isExporting = false;
    }
  }
}

